// src/screens/FormDetailScreen.css.js
import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  // Navegação para perguntas
  navButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  navButtonText: {
    fontSize: 12,
    fontWeight: '500',
  },
  navEssentialBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF3CD',
    borderWidth: 1,
    borderColor: '#FFC107',
    borderRadius: 3,
    paddingHorizontal: 3,
    paddingVertical: 1,
  },
  navEssentialIcon: {
    fontSize: 8,
    marginRight: 1,
  },
  navEssentialText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#DC3545',
  },

  // Container principal
  container: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
    minHeight: '100vh',
  },
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontWeight: 'bold',
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    opacity: 0.9,
  },

  // Loading Container
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: AVAQualisTheme.spacing.xl,
  },
  loadingText: {
    color: AVAQualisTheme.colors.primary,
    marginTop: AVAQualisTheme.spacing.md,
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  loadingSubtext: {
    color: AVAQualisTheme.colors.secondary,
    marginTop: AVAQualisTheme.spacing.xs,
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.md,
  },

  // Fixed header container (cabeçalho fixo)
  fixedHeaderContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    zIndex: 10,
    margin: 0,
    padding: 0,
  },

  // Container de progresso
  progressContainer: {
    paddingTop: AVAQualisTheme.spacing.md,
    paddingLeft: AVAQualisTheme.spacing.md,
    paddingRight: AVAQualisTheme.spacing.md,
    paddingBottom: 0,
    backgroundColor: AVAQualisTheme.colors.surface,
    flexShrink: 0,
    margin: 0,
  },
  progressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: AVAQualisTheme.spacing.xs,
    flexWrap: 'wrap',
    margin: 0,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  progressInfo: {
    flex: 1,
    minWidth: 200,
  },
  progressTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: AVAQualisTheme.spacing.sm,
  },
  progressText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    flexShrink: 0,
  },
  progressSubtext: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
    flexShrink: 0,
  },
  progressIdText: {
    fontSize: 10,
    color: '#999',
    fontWeight: '400',
    flexShrink: 0,
  },
  progressBadge: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  progressBar: {
    height: 8,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    marginTop: AVAQualisTheme.spacing.xs,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },

  // Avisos de status
  completionNotice: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: AVAQualisTheme.spacing.xs,
    paddingBottom: AVAQualisTheme.spacing.xs,
    paddingLeft: AVAQualisTheme.spacing.sm,
    paddingRight: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.warning}15`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.warning,
    minHeight: 35,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    alignSelf: 'stretch',
  },
  completionNoticeText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.warning,
    fontWeight: '600',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  },
  editingNotice: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: AVAQualisTheme.spacing.xs,
    paddingBottom: AVAQualisTheme.spacing.xs,
    paddingLeft: AVAQualisTheme.spacing.sm,
    paddingRight: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
    minHeight: 35,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    alignSelf: 'stretch',
  },
  editingNoticeText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.info,
    fontWeight: '600',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  },

  // Navegação entre perguntas
  questionNav: {
    backgroundColor: 'transparent',
    paddingTop: 0,
    paddingBottom: AVAQualisTheme.spacing.sm,
    paddingLeft: AVAQualisTheme.spacing.md,
    paddingRight: AVAQualisTheme.spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
    flexShrink: 0,
    maxHeight: 70,
    margin: 0,
  },
  questionNavTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.xs,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  questionNavScroll: {
    flexDirection: 'row',
    margin: 0,
    padding: 0,
  },
  questionNavButton: {
    marginRight: AVAQualisTheme.spacing.xs,
    minWidth: 50,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
  },

  // Container principal de conteúdo
  scrollContainer: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  content: {
    flexGrow: 1,
    padding: AVAQualisTheme.spacing.md,
    paddingTop: AVAQualisTheme.spacing.sm,
    paddingBottom: 100,
  },

  // Seções
  sectionContainer: {
    marginBottom: AVAQualisTheme.spacing.lg,
    flexShrink: 0,
  },
  sectionHeader: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  sectionHeaderContent: {
    padding: AVAQualisTheme.spacing.md,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sectionInfo: {
    flex: 1,
  },
  sectionLabel: {
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  sectionType: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  sectionCategory: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  sectionSubcategory: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '600',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  sectionStats: {
    fontSize: 12,
    color: AVAQualisTheme.colors.outline,
    fontStyle: 'italic',
  },
  sectionToggle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  questionsContainer: {
    paddingLeft: AVAQualisTheme.spacing.sm,
  },

  // Perguntas
  questionContainer: {
    marginBottom: AVAQualisTheme.spacing.lg,
    flexShrink: 0,
  },
  questionContainerEditing: {
    backgroundColor: `${AVAQualisTheme.colors.info}05`,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    padding: AVAQualisTheme.spacing.xs,
  },
  questionCard: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 4,
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  questionCardEditing: {
    borderLeftColor: AVAQualisTheme.colors.info,
    borderLeftWidth: 6,
  },
  questionHeader: {
    marginBottom: AVAQualisTheme.spacing.md,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  questionMeta: {
    flex: 1,
  },
  questionCodeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.sm,
    flexWrap: 'wrap',
  },
  questionCodeChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    borderColor: AVAQualisTheme.colors.info,
  },
  essentialBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF3CD',
    borderWidth: 1,
    borderColor: '#FFC107',
    borderRadius: AVAQualisTheme.borderRadius.sm,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
    paddingVertical: 2,
  },
  essentialIcon: {
    fontSize: 12,
    marginRight: 2,
  },
  essentialText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#DC3545',
  },
  editingChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}20`,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.info,
  },
  editingChipText: {
    fontSize: 10,
    color: AVAQualisTheme.colors.info,
    fontWeight: 'bold',
  },
  questionStatus: {
    alignItems: 'flex-end',
  },
  questionStatusText: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.success,
  },
  requirementLabel: {
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  questionTitle: {
    fontSize: 18,
    marginBottom: AVAQualisTheme.spacing.md,
    lineHeight: 26,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '700',
  },

  // Detalhes da pergunta
  detailsContainer: {
    marginBottom: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  detailsLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  detailsText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 20,
  },
  segmentoContainer: {
    marginBottom: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.tertiary}08`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.tertiary,
  },
  segmentoLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.tertiary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  segmentoText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 18,
    fontStyle: 'italic',
    fontWeight: '500',
  },

  // Opções de resposta
  optionsContainer: {
    marginTop: AVAQualisTheme.spacing.sm,
    gap: AVAQualisTheme.spacing.sm,
  },
  radioOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.sm,
    paddingHorizontal: AVAQualisTheme.spacing.md,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  radioOptionSelected: {
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
    borderColor: AVAQualisTheme.colors.primary,
  },
  radioLabel: {
    flex: 1,
    marginLeft: AVAQualisTheme.spacing.sm,
    fontSize: 16,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 22,
  },

  // Não se aplica
  notApplicableReasonContainer: {
    marginTop: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.warning}10`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.warning,
  },
  notApplicableReasonLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.warning,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  notApplicableReasonText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontStyle: 'italic',
  },

  // Findings (Achados)
  findingsContainer: {
    marginTop: AVAQualisTheme.spacing.md,
    gap: AVAQualisTheme.spacing.sm,
  },
  findingsLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
  },
  findingsInput: {
    backgroundColor: AVAQualisTheme.colors.background,
    fontSize: 16,
  },
  placeholderText: {
    color: AVAQualisTheme.colors.outline,
    fontStyle: 'italic',
  },
  saveFindingButton: {
    alignSelf: 'flex-start',
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  savedFindingContainer: {
    marginTop: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.success}10`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.success,
  },
  savedFindingLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.success,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  savedFindingText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 20,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  editFindingButton: {
    alignSelf: 'flex-start',
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderColor: AVAQualisTheme.colors.primary,
  },

  // Preview da resposta
  answerPreview: {
    marginTop: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.success}10`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.success,
  },
  answerPreviewLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.success,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  answerPreviewText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontStyle: 'italic',
  },

  // Anexos
  attachmentPreview: {
    marginTop: AVAQualisTheme.spacing.md,
    padding: AVAQualisTheme.spacing.sm,
    backgroundColor: `${AVAQualisTheme.colors.info}08`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  attachmentPreviewCompact: {
    marginTop: AVAQualisTheme.spacing.xs,
    padding: AVAQualisTheme.spacing.xs,
    backgroundColor: `${AVAQualisTheme.colors.info}05`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  attachmentPreviewTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.info,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  attachmentPreviewTitleCompact: {
    fontSize: 11,
    fontWeight: '600',
    color: AVAQualisTheme.colors.info,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  attachmentItem: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    marginBottom: AVAQualisTheme.spacing.xs,
    elevation: 1,
  },
  attachmentItemCompact: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    marginBottom: AVAQualisTheme.spacing.xs,
    elevation: 1,
  },
  attachmentItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: AVAQualisTheme.spacing.xs,
  },
  attachmentItemIcon: {
    fontSize: 20,
    marginRight: AVAQualisTheme.spacing.sm,
    textAlign: 'center',
    minWidth: 24,
  },
  attachmentItemDetails: {
    flex: 1,
    marginRight: AVAQualisTheme.spacing.xs,
  },
  attachmentItemName: {
    fontSize: 13,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: 2,
  },
  attachmentItemNameCompact: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
  },
  attachmentItemDescription: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
    marginBottom: 2,
  },
  attachmentItemDate: {
    fontSize: 10,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '500',
  },
  viewButton: {
    margin: 0,
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
  },
  viewButtonCompact: {
    margin: 0,
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
  },

  // Ações finais
  finalActions: {
    marginVertical: AVAQualisTheme.spacing.lg,
    gap: AVAQualisTheme.spacing.md,
  },
  saveButton: {
    borderColor: AVAQualisTheme.colors.primary,
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  completeButton: {
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  completeButtonDisabled: {
    opacity: 0.6,
  },
  finalizationWarning: {
    marginTop: AVAQualisTheme.spacing.sm,
    padding: AVAQualisTheme.spacing.md,
    backgroundColor: `${AVAQualisTheme.colors.warning}10`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.warning,
  },
  finalizationWarningText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.warning,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  finalizationWarningSubtext: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    fontWeight: '500',
  },

  // Resumo das respostas
  summaryCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    maxHeight: 300,
    marginBottom: AVAQualisTheme.spacing.lg,
  },
  summaryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  summaryTitle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  summaryBadge: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  summaryScroll: {
    maxHeight: 200,
  },
  summaryItem: {
    marginBottom: AVAQualisTheme.spacing.md,
    paddingBottom: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  summaryItemHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  summaryQuestion: {
    flex: 1,
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.xs,
    lineHeight: 18,
    fontWeight: '500',
  },
  editIconButton: {
    margin: 0,
  },
  summaryAnswer: {
    fontSize: 14,
    fontWeight: '500',
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 20,
  },
  summaryNotApplicableReason: {
    fontSize: 12,
    color: AVAQualisTheme.colors.warning,
    fontStyle: 'italic',
    marginTop: AVAQualisTheme.spacing.xs,
  },
  summaryFinding: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
    marginTop: AVAQualisTheme.spacing.xs,
  },
  summaryAttachments: {
    fontSize: 12,
    color: AVAQualisTheme.colors.info,
    fontStyle: 'italic',
    marginTop: AVAQualisTheme.spacing.xs,
    fontWeight: '600',
  },

  // Espaçador
  bottomSpacer: {
    height: AVAQualisTheme.spacing.xl,
  },

  // Estilos para o Custom Dialog
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  dialogContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    minWidth: 300,
    maxWidth: '90%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  dialogHeader: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
  },
  dialogTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  dialogContent: {
    paddingHorizontal: 24,
    paddingBottom: 20,
  },
  dialogMessage: {
    fontSize: 16,
    lineHeight: 24,
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  dialogActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 8,
  },
  dialogButton: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: AVAQualisTheme.borderRadius.md,
    minWidth: 80,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogButtonSecondary: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  dialogButtonPrimary: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  dialogButtonText: {
    fontSize: 14,
    fontWeight: '600',
  },
  dialogButtonTextSecondary: {
    color: AVAQualisTheme.colors.primary,
  },
  dialogButtonTextPrimary: {
    color: AVAQualisTheme.colors.onPrimary,
  },

  // Estilos para dialog "Não se Aplica"
  notApplicableInput: {
    backgroundColor: AVAQualisTheme.colors.background,
    fontSize: 16,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  characterCount: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'right',
  },

  buttonDisabledStyle: {
    opacity: 0.7,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.warning,
    borderStyle: 'dashed',
  },

  // Se ainda não existir, adicione também:
  saveButton: {
    marginBottom: AVAQualisTheme.spacing.sm,
    elevation: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },

  completeButton: {
    backgroundColor: AVAQualisTheme.colors.success,
    elevation: 4,
    shadowColor: AVAQualisTheme.colors.success,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
  },

  // Grupo do Requisito
  grupoRequisitoContainer: {
    marginTop: 12,
    backgroundColor: '#E8F5E9',
    padding: 10,
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#4CAF50',
  },
  grupoRequisitoLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1B5E20',
    marginBottom: 4,
  },
  grupoRequisitoText: {
    fontSize: 14,
    color: '#2E7D32',
    fontWeight: '500',
  },

  // Sugestão de Roteiro

  sugestaoRoteiroContainer: {
    marginTop: 12,
    backgroundColor: '#E3F2FD',
    padding: 8, // Menor
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#2196F3',
  },
  sugestaoRoteiroLabel: {
    fontSize: 13, // Menor
    fontWeight: 'bold',
    color: '#0D47A1',
    marginBottom: 4,
  },
  sugestaoRoteiroText: {
    fontSize: 12, // Menor
    fontStyle: 'italic',
    color: '#1565C0',
    lineHeight: 18, // Reduzido
  },
});
